import { render, staticRenderFns } from "./CatalogoDocumentos.vue?vue&type=template&id=5e90d500&scoped=true"
import script from "./CatalogoDocumentos.vue?vue&type=script&lang=js"
export * from "./CatalogoDocumentos.vue?vue&type=script&lang=js"
import style0 from "./CatalogoDocumentos.vue?vue&type=style&index=0&id=5e90d500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e90d500",
  null
  
)

export default component.exports